// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AutoCompleteAddressCmp_wrapper__ka_vr","text":"AutoCompleteAddressCmp_text__p6MNV","subtext":"AutoCompleteAddressCmp_subtext__3kS7h"};